export const URL_TYPE_CONFIG = {
   image: { request: 'user/media/images/url', type: 'GuideImage', idField: 'guid' },
   document: { request: 'user/media/documents/url', type: 'Document', idField: 'guid' },
   embed: { request: 'user/media/embed', type: null, idField: 'objectid' },
} as const;

type UrlType = keyof typeof URL_TYPE_CONFIG;

type UrlTypeConfig = (typeof URL_TYPE_CONFIG)[UrlType];

interface UrlTypeResult {
   urlType: UrlType;
   extension: string | undefined;
   config: UrlTypeConfig;
}

export function getUrlTypeConfig(
   url: string,
   imageExtensions: Record<string, string>,
   documentExtensions: Record<string, string>
): UrlTypeResult {
   const extension = url.split('/').pop()?.split('?')[0].split('.').pop()?.toLowerCase();

   const urlType: UrlType =
      extension && imageExtensions[extension]
         ? 'image'
         : extension && documentExtensions[extension]
           ? 'document'
           : 'embed';

   return { urlType, extension, config: URL_TYPE_CONFIG[urlType] };
}
